export interface ISuppliars {
  ID: number;
  oid: string;
  ClientName: string;
  ClientClass: string;
}

export interface IClientMainData {
  _id: string;
  ID: number;
  suppliarClass: string;
}

export interface ICompetitorDiscount {
  itemBodyID: string;
  OfferID: string;
  ClientID: IClientMainData;
  ClientName: string;
  ClientItemName: string;
  Price: number;
  Discount: number;
}

export interface IItemData {
  ID: number;
  Name: string;
  Price: number;
}

export interface IHandRequestInitialData {
  suppliars: ISuppliars[];
  items: IItemData[];
}

export enum IRequestType {
  'Eva' = 'Eva',
  'Stores' = 'Stores',
  'IbnSina' = 'IbnSina',
}

// create a type for the request type with arabic meaning
export type IRequestTypeArabic = {
  [key in IRequestType]: string;
};

export const RequestTypeArabic: IRequestTypeArabic = {
  [IRequestType.Eva]: 'اخناتون',
  [IRequestType.Stores]: 'مخازن',
  [IRequestType.IbnSina]: 'ابن سينا',
};

export interface ISuppliarWithDebt extends ISuppliars {
  Debt: number;
  DebtStatus: 'خالص' | 'مديون' | 'دائن';
}

export interface IItemLastBatch {
  ID: number;
  TrDate: string;
  ExpireDate: string;
  BNO: string;
}

export interface IItemLastIncoming {
  ID: number;
  TrDate: string;
  Qty: number;
  UnitPrice: number;
  Discount: number;
  DiscountPro: number;
  Bonus: number;
  ExpireDate: string;
  BNO: string;
}

export interface IOffers {
  min: number;
  max: number;
  countSuppliers: number;
  countOffers: number;
  underRequest: number;
}

export interface IItemDataCount {
  IsMain: boolean;
  ID: number;
  Name: string;
  Price: number;
  AllCount: number;
  Store1Count: number;
  Store1Sales: number;
  Store1Returns: number;
  Store1NetSales: number;
  Store2Count: number;
  Store2Sales: number;
  Store2Returns: number;
  Store2NetSales: number;
  StoreOtherCount: number;
  RetailDiff: number;
  RetailStatus: 'needStock' | 'canTransfer' | 'noTrans' | 'overStock';
  WholeSaleStatus: 'needStock' | 'canTransfer' | 'noTrans' | 'overStock';
  WholeSaleDiff: number;
}

export interface IItemDataResponse {
  itemLastBatch: IItemLastBatch;
  itemLastIncoming: IItemLastIncoming;
  itemLastIncomingBySupplier: IItemLastIncoming | null;
  isGroup: boolean;
  AllItemsData: IItemDataCount[];
  OtherItemDataCount: number;
  offers: IOffers;
}

export interface IPurchaseRequestItemBody {
  _id: string | null;
  TempID: string;
  Item_ID: number;
  ItemName: string;
  Price: number;
  MainPrice: number;
  Discount: number;
  FinishDiscount: number;
  Qty: number;
  Bonus: number;
  Tax: number;
  TotalTax: number;
  BNO: string;
  ExpireDate: string;
  DiscountPro: number;
  DiscountStatus: 'best' | 'accept' | 'bad' | 'only' | 'static';
  WholeSaleStatus: 'needStock' | 'canTransfer' | 'noTrans' | 'overStock';
  RetailStatus: 'needStock' | 'canTransfer' | 'noTrans' | 'overStock';
  TotalAfterDiscount: number;
  TotalCustomerPrice: number;
  UnderRequest: number | null;
}

// Backend DTO interfaces
export interface SaveRequestItemDto {
  HealthyItemID: number;
  Qty: number;
  Bonus: number;
  Price: number;
  Discount: number;
  DiscountPro: number;
  Tax: number;
  BNO: string;
  ExpireDate: string;
  DiscountStatus: 'best' | 'accept' | 'bad' | 'only' | 'static';
  WholeSaleStatus: 'needStock' | 'canTransfer' | 'noTrans' | 'overStock';
  RetailStatus: 'needStock' | 'canTransfer' | 'noTrans' | 'overStock';
  UnderRequest: number;
}

export interface SaveRequestDto {
  clientID: string;
  notes?: string;
  offerID?: string;
  items: SaveRequestItemDto[];
}

export interface UpdateRequestDto extends SaveRequestDto {
  headID: string;
}
